module.exports = __webpack_public_path__ + "0bbe1f5a7e7bc6ab3e77def59f67419f.pdf";